/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Aggregated routes for the application.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:53 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/17/2018  NJN     Add Components and Component Pages
 *      09/18/2018  NJN     Add Navs
 *      09/24/2018  NJN     Added System Block Validation Types
 *      09/25/2018  NJN     Add BlockValidationTypeFields
 *      09/27/2018  NJN     Add BlockElementOptions, BlockElementTypes, BlockGroups
 *      09/30/2018  NJN     Add Blocks
 *      10/28/2018  NJN     Add BlockDatas, BlockFormatLevels
 *      12/02/2018  NJN     Add FileTypes
 *      12/03/2018  NJN     Add Contacts
 *      12/19/2018  NJN     Add Transactions
 *      01/21/2019  NJN     Add Consequences
 *      01/21/2019  NJN     Add Probabilities
 *      01/21/2019  NJN     Add RiskClasses
 *      01/21/2019  NJN     Add RiskMatrix
 *      01/21/2019  NJN     Add Assets
 *      03/06/2019  NJN     Add Field Set Groups, Field Sets, Fields
 *      04/01/2019  NJN     Add GCSEquipments, Inspections
 *      05/13/2019  NJN     Add Location States, Countries, Counties, Zip Codes
 *      06/15/2019  NJN     Add Projects, Versions
 *      06/27/2019  NJN     Add Project Jobs
 *      07/06/2019  NJN     Add GoCampaign_PoliticalDistrictGroups, LocationCities
 *      07/10/2019  NJN     Add GoCampaign_PoliticalDistricts
 *      07/11/2019  NJN     Add GoCampaign_OfficeGroups
 *      09/29/2019  NJN     Add GoCampaign_PrecinctGroups, VoterDB_Voters
 *      10/26/2019  NJN     Add GoCampaign_Counties, GoCampaign_Precincts
 *      12/09/2019  NJN     Add ExportTypes, ExportTypeFilters, ExportJobs
 *      
 *      
 *  Copyright (c) 2018-2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

import Home from '../containers/Home';

/*  Authorization & Security */
import { Roles, RoleEdit } from './routesSystemSecurity';

/*  Companies & Users */
import { Companies, CompanyEdit, CompanyStatuses, CompanyStatusEdit } from './routesCompanies';
import { Users, UserEdit, UserStatuses, UserStatusEdit} from './routesUsers';
import { CurrentUserProfile } from './routesCurrentUser';

/*  System Components */
import { SystemDataTypes, SystemDataTypeEdit, EmailSettings } from './routesSystemSettings';
import { FileTypeList, FileTypeForm } from './routesFileTypes';
import { SystemListGroups, SystemListGroupEdit, SystemLists, SystemListEdit, SystemListItems, SystemListItemEdit} from './routesSystemLists';
import { NavGroups, NavGroupEdit, Navs, NavEdit, NavTypes, NavTypeEdit, ComponentGroups, ComponentGroupEdit, Components, ComponentEdit, ComponentPages, ComponentPageEdit } from './routesSystemNavigation';
import { SystemBlockValidationTypeList, SystemBlockValidationTypeEdit } from './routesSystemBlocks';
import { BlockValidationTypeFieldList, BlockValidationTypeFieldEdit } from './routesBlockValidationTypeFields';
import { BlockElementOptionList, BlockElementOptionForm } from './routesBlockElementOptions';
import { BlockElementTypeList, BlockElementTypeForm } from './routesBlockElementTypes';
import { BlockGroupList, BlockGroupForm } from './routesBlockGroups';
import { BlocksList, BlocksForm } from './routesBlocks';
import { BlockElementForm } from './routesBlockElements';
import { BlockDataList, BlockDataForm } from './routesBlockDatas';
import { BlockFormatList, BlockFormatForm } from './routesBlockFormats';
import { BlockFormatLevelList, BlockFormatLevelForm } from './routesBlockFormatLevels';
import { AdminSettingList, AdminSettingForm } from './routesAdminSettings';
import { FieldSetGroupList, FieldSetGroupForm } from './routesFieldSetGroups';
import { FieldSetList, FieldSetForm } from './routesFieldSets';
import { FieldList, FieldForm } from './routesFields';

/*  Advarion CMS */
import { FolderList, FolderForm } from './routesFolders';

/*  Advarion CRM */
import { ContactList, ContactForm } from './routesContacts';
import { LocationStateList, LocationStateForm } from './routesLocationStates';
import { LocationCountryList, LocationCountryForm } from './routesLocationCountries';
import { LocationCountyList, LocationCountyForm } from './routesLocationCounties';
import { LocationZipCodeList, LocationZipCodeForm } from './routesLocationZipCodes';
import { LocationCityList, LocationCityForm } from './routesLocationCities';

/*  Advarion Projects */
import { Project_ProjectList, Project_ProjectForm } from './routesProject_Projects';
import { Project_ProjectVersionList, Project_ProjectVersionForm } from './routesProject_ProjectVersions';
import { Project_ProjectJobList, Project_ProjectJobForm } from './routesProject_ProjectJobs';

/*  Gulf Crane Custom */
import { ConsequenceList, ConsequenceForm } from './routesConsequences';
import { ProbabilityList, ProbabilityForm } from './routesProbabilities';
import { RiskClassList, RiskClassForm } from './routesRiskClasses';
import { RiskMatrixList, RiskMatrixForm } from './routesRiskMatrix';
import { AssetList, AssetForm } from './routesAssets';
import { GCSEquipmentList, GCSEquipmentForm } from './routesGCSEquipments';
import { GCSInspectionList, GCSInspectionForm } from './routesGCSInspections';

/*  GoCampaign */
import { GoCampaign_PoliticalDistrictGroupList, GoCampaign_PoliticalDistrictGroupForm } from './routesGoCampaign_PoliticalDistrictGroups';
import { GoCampaign_PoliticalDistrictList, GoCampaign_PoliticalDistrictForm } from './routesGoCampaign_PoliticalDistricts';
import { GoCampaign_OfficeGroupList, GoCampaign_OfficeGroupForm } from './routesGoCampaign_OfficeGroups';
import { GoCampaign_PrecinctGroupList, GoCampaign_PrecinctGroupForm } from './routesGoCampaign_PrecinctGroups';
import { GoCampaign_CountyList, GoCampaign_CountyForm } from './routesGoCampaign_Counties';
import { GoCampaign_PrecinctList, GoCampaign_PrecinctForm } from './routesGoCampaign_Precincts';

/* VoterDB */
import { VoterDB_VotersList, VoterDB_VotersForm } from './routesVoterDB_Voters';
import { ExportTypeList, ExportTypeForm } from './routesExportTypes';
import { ExportTypeFilterList, ExportTypeFilterForm } from './routesExportTypeFilters';
import { ExportJobList, ExportJobForm } from './routesExportJobs';

/*  Dashboard */
function Loading() {
    return <div>Loading...</div>;
}

const Dashboard = Loadable({
    loader: () => import('../containers/views/Dashboard'),
    loading: Loading,
});

const routes = [
    { path: '/', name: '', component: Home, exact: true },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },

/*  Authorization & Security */
    { path: '/roles', name: 'Roles', component: Roles },
    { path: '/role', name: 'Role', component: RoleEdit, exact: true },
    { path: '/role/:id', name: 'Role', component: RoleEdit },

/*  Companies & Users */
    { path: '/companies', name: 'Companies', component: Companies },
    { path: '/company', name: 'Company', component: CompanyEdit, exact: true },
    { path: '/company/:id', name: 'Company', component: CompanyEdit },

    { path: '/company-statuses', name: 'Company Statuses', component: CompanyStatuses },
    { path: '/company-status', name: 'Company Status', component: CompanyStatusEdit, exact: true },
    { path: '/company-status/:id', name: 'Company Status', component: CompanyStatusEdit },

    { path: '/users', name: 'Users', component: Users },
    { path: '/user', name: 'User', component: UserEdit, exact: true },
    { path: '/user/:id', name: 'User', component: UserEdit },

    { path: '/user-statuses', name: 'User Statuses', component: UserStatuses },
    { path: '/user-status', name: 'User Status', component: UserStatusEdit, exact: true },
    { path: '/user-status/:id', name: 'User Status', component: UserStatusEdit },

    { path: '/current-user-profile', name: 'Current User Profile', component: CurrentUserProfile, exact: true },

/*  System Components */
    { path: '/admin-settings', name: 'Admin Setting List', component: AdminSettingList },
    { path: '/admin-setting', name: 'Admin Setting Add', component: AdminSettingForm, exact: true },
    { path: '/admin-setting/:id', name: 'Admin Setting Edit', component: AdminSettingForm },

    { path: '/system-data-types', name: 'System Data Types', component: SystemDataTypes },
    { path: '/system-data-type', name: 'System Data Type', component: SystemDataTypeEdit, exact: true },
    { path: '/system-data-type/:id', name: 'System Data Type', component: SystemDataTypeEdit },

    { path: '/file-types', name: 'File Type List', component: FileTypeList },
    { path: '/file-type', name: 'File Type Add', component: FileTypeForm, exact: true },
    { path: '/file-type/:id', name: 'File Type Edit', component: FileTypeForm },

    { path: '/email-settings', name: 'Email Settings', component: EmailSettings, exact: true },

    { path: '/system-list-groups', name: 'System List Groups', component: SystemListGroups },
    { path: '/system-list-group', name: 'System List Group', component: SystemListGroupEdit, exact: true },
    { path: '/system-list-group/:id', name: 'System List Group', component: SystemListGroupEdit },

    { path: '/system-lists', name: 'System Lists', component: SystemLists },
    { path: '/system-list', name: 'System List', component: SystemListEdit, exact: true },
    { path: '/system-list/:id', name: 'System List', component: SystemListEdit },

    { path: '/system-list-items', name: 'System List Items', component: SystemListItems },
    { path: '/system-list-item', name: 'System List Item', component: SystemListItemEdit, exact: true },
    { path: '/system-list-item/:id', name: 'System List Item', component: SystemListItemEdit },

    { path: '/nav-groups', name: 'Nav Groups', component: NavGroups },
    { path: '/nav-group', name: 'Nav Group', component: NavGroupEdit, exact: true },
    { path: '/nav-group/:id', name: 'Nav Group', component: NavGroupEdit },

    { path: '/navs', name: 'Navs', component: Navs },
    { path: '/nav', name: 'Nav', component: NavEdit, exact: true },
    { path: '/nav/:id', name: 'Nav', component: NavEdit },

    { path: '/nav-types', name: 'Nav Types', component: NavTypes },
    { path: '/nav-type', name: 'Nav Type', component: NavTypeEdit, exact: true },
    { path: '/nav-type/:id', name: 'Nav Type', component: NavTypeEdit },

    { path: '/component-groups', name: 'Component Groups', component: ComponentGroups },
    { path: '/component-group', name: 'Component Group', component: ComponentGroupEdit, exact: true },
    { path: '/component-group/:id', name: 'Component Group', component: ComponentGroupEdit },

    { path: '/components', name: 'Components', component: Components },
    { path: '/component', name: 'Component', component: ComponentEdit, exact: true },
    { path: '/component/:id', name: 'Component', component: ComponentEdit },

    { path: '/component-pages', name: 'Component Pages', component: ComponentPages },
    { path: '/component-page', name: 'Component Page', component: ComponentPageEdit, exact: true },
    { path: '/component-page/:id', name: 'Component Page', component: ComponentPageEdit },

    { path: '/block-validation-types', name: 'Block Validation Type List', component: SystemBlockValidationTypeList },
    { path: '/block-validation-type', name: 'Block Validation Type Add', component: SystemBlockValidationTypeEdit, exact: true },
    { path: '/block-validation-type/:id', name: 'Block Validation Type Edit', component: SystemBlockValidationTypeEdit },

    { path: '/block-validation-type-fields', name: 'Validation Field List', component: BlockValidationTypeFieldList },
    { path: '/block-validation-type-field', name: 'Validation Field Add', component: BlockValidationTypeFieldEdit, exact: true },
    { path: '/block-validation-type-field/:id', name: 'Validation Field Edit', component: BlockValidationTypeFieldEdit },

    { path: '/block-element-options', name: 'Element Option List', component: BlockElementOptionList },
    { path: '/block-element-option', name: 'Element Option Add', component: BlockElementOptionForm, exact: true },
    { path: '/block-element-option/:id', name: 'Element Option Edit', component: BlockElementOptionForm },

    { path: '/block-element-types', name: 'Element Type List', component: BlockElementTypeList },
    { path: '/block-element-type', name: 'Element Type Add', component: BlockElementTypeForm, exact: true },
    { path: '/block-element-type/:id', name: 'Element Type Edit', component: BlockElementTypeForm },

    { path: '/block-groups', name: 'Block Group List', component: BlockGroupList },
    { path: '/block-group', name: 'Block Group Add', component: BlockGroupForm, exact: true },
    { path: '/block-group/:id', name: 'Block Group Edit', component: BlockGroupForm },

    { path: '/blocks', name: 'Block List', component: BlocksList },
    { path: '/block', name: 'Block Add', component: BlocksForm, exact: true },
    { path: '/block/:id', name: 'Block Edit', component: BlocksForm },
    { path: '/block-element', name: 'Block Element Add', component: BlockElementForm, exact: true },
    { path: '/block-element/:id', name: 'Block Element Edit', component: BlockElementForm },

    { path: '/block-datas', name: 'Block Data List', component: BlockDataList },
    { path: '/block-data', name: 'Block Data Add', component: BlockDataForm, exact: true },
    { path: '/block-data/:id', name: 'Block Data Edit', component: BlockDataForm },

    { path: '/block-formats', name: 'Block Format List', component: BlockFormatList },
    { path: '/block-format', name: 'Block Format Add', component: BlockFormatForm, exact: true },
    { path: '/block-format/:id', name: 'Block Format Edit', component: BlockFormatForm },
    { path: '/block-format-levels', name: 'Block Format Level List', component: BlockFormatLevelList },
    { path: '/block-format-level', name: 'Block Format Level Add', component: BlockFormatLevelForm, exact: true },
    { path: '/block-format-level/:id', name: 'Block Format Level Edit', component: BlockFormatLevelForm },

    { path: '/field-set-groups', name: 'Field Set Group List', component: FieldSetGroupList },
    { path: '/field-set-group', name: 'Field Set Group Add', component: FieldSetGroupForm, exact: true },
    { path: '/field-set-group/:id', name: 'Field Set Group Edit', component: FieldSetGroupForm },

    { path: '/field-sets', name: 'Field Set List', component: FieldSetList },
    { path: '/field-set', name: 'Field Set Add', component: FieldSetForm, exact: true },
    { path: '/field-set/:id', name: 'Field Set Edit', component: FieldSetForm },

    { path: '/fields', name: 'Field List', component: FieldList },
    { path: '/field', name: 'Field Add', component: FieldForm, exact: true },
    { path: '/field/:id', name: 'Field Edit', component: FieldForm },

/*  Advarion CMS */
    { path: '/folders', name: 'Folder List', component: FolderList },
    { path: '/folder', name: 'Folder Add', component: FolderForm, exact: true },
    { path: '/folder/:id', name: 'Folder Edit', component: FolderForm },

/*  Advarion CRM */
    { path: '/contacts', name: 'Contact List', component: ContactList },
    { path: '/contact', name: 'Contact Add', component: ContactForm, exact: true },
    { path: '/contact/:id', name: 'Contact Edit', component: ContactForm },

    { path: '/location-states', name: 'State List', component: LocationStateList },
    { path: '/location-state', name: 'State Add', component: LocationStateForm, exact: true },
    { path: '/location-state/:id', name: 'State Edit', component: LocationStateForm },

    { path: '/location-countries', name: 'Location Country List', component: LocationCountryList },
    { path: '/location-country', name: 'Location Country Add', component: LocationCountryForm, exact: true },
    { path: '/location-country/:id', name: 'Location Country Edit', component: LocationCountryForm },

    { path: '/location-counties', name: 'Location County List', component: LocationCountyList },
    { path: '/location-county', name: 'Location County Add', component: LocationCountyForm, exact: true },
    { path: '/location-county/:id', name: 'Location County Edit', component: LocationCountyForm },

    { path: '/location-zipcodes', name: 'Location Zip Code List', component: LocationZipCodeList },
    { path: '/location-zipcode', name: 'Location Zip Code Add', component: LocationZipCodeForm, exact: true },
    { path: '/location-zipcode/:id', name: 'Location Zip Code Edit', component: LocationZipCodeForm },

    { path: '/location-cities', name: 'Location Cities List', component: LocationCityList },
    { path: '/location-city', name: 'Location Cities Add', component: LocationCityForm, exact: true },
    { path: '/location-city/:id', name: 'Location Cities Edit', component: LocationCityForm },

/*  Advarion Projects */
    { path: '/projects', name: 'Project List', component: Project_ProjectList },
    { path: '/project', name: 'Project Add', component: Project_ProjectForm, exact: true },
    { path: '/project/:id', name: 'Project Edit', component: Project_ProjectForm },

    { path: '/project-versions', name: 'Project Version List', component: Project_ProjectVersionList },
    { path: '/project-version', name: 'Project Version Add', component: Project_ProjectVersionForm, exact: true },
    { path: '/project-version/:id', name: 'Project Version Edit', component: Project_ProjectVersionForm },

    { path: '/project-jobs', name: 'Project Job List', component: Project_ProjectJobList },
    { path: '/project-job', name: 'Project Job Add', component: Project_ProjectJobForm, exact: true },
    { path: '/project-job/:id', name: 'Project Job Edit', component: Project_ProjectJobForm },

/*  Gulf Crane Custom */
    { path: '/consequences', name: 'Consequence List', component: ConsequenceList },
    { path: '/consequence', name: 'Consequence Add', component: ConsequenceForm, exact: true },
    { path: '/consequence/:id', name: 'Consequence Edit', component: ConsequenceForm },

    { path: '/probabilities', name: 'Probability List', component: ProbabilityList },
    { path: '/probability', name: 'Probability Add', component: ProbabilityForm, exact: true },
    { path: '/probability/:id', name: 'Probability Edit', component: ProbabilityForm },

    { path: '/risk-classes', name: 'Risk Class List', component: RiskClassList },
    { path: '/risk-class', name: 'Risk Class Add', component: RiskClassForm, exact: true },
    { path: '/risk-class/:id', name: 'Risk Class Edit', component: RiskClassForm },

    { path: '/risk-matrixes', name: 'Risk Matrix List', component: RiskMatrixList },
    { path: '/risk-matrix', name: 'Risk Matrix Add', component: RiskMatrixForm, exact: true },
    { path: '/risk-matrix/:id', name: 'Risk Matrix Edit', component: RiskMatrixForm },

    { path: '/assets', name: 'Asset List', component: AssetList },
    { path: '/asset', name: 'Asset Add', component: AssetForm, exact: true },
    { path: '/asset/:id', name: 'Asset Edit', component: AssetForm },

    { path: '/gcsequipments', name: 'GCS Equipment List', component: GCSEquipmentList },
    { path: '/gcsequipment', name: 'GCS Equipment Add', component: GCSEquipmentForm, exact: true },
    { path: '/gcsequipment/:id', name: 'GCS Equipment Edit', component: GCSEquipmentForm },

    { path: '/gcsinspections', name: 'GCS Inspection List', component: GCSInspectionList },
    { path: '/gcsinspection', name: 'GCS Inspection Add', component: GCSInspectionForm, exact: true },
    { path: '/gcsinspection/:id', name: 'GCS Inspection Edit', component: GCSInspectionForm },

/*  GoCampaign */
    { path: '/political-district-groups', name: 'Political District Group List', component: GoCampaign_PoliticalDistrictGroupList },
    { path: '/political-district-group', name: 'Political District Group Add', component: GoCampaign_PoliticalDistrictGroupForm, exact: true },
    { path: '/political-district-group/:id', name: 'Political District Group Edit', component: GoCampaign_PoliticalDistrictGroupForm },

    { path: '/political-districts', name: 'Political District List', component: GoCampaign_PoliticalDistrictList },
    { path: '/political-district', name: 'Political District Add', component: GoCampaign_PoliticalDistrictForm, exact: true },
    { path: '/political-district/:id', name: 'Political District Edit', component: GoCampaign_PoliticalDistrictForm },

    { path: '/gocampaign-office-groups', name: 'Office Group List', component: GoCampaign_OfficeGroupList },
    { path: '/gocampaign-office-group', name: 'Office Group Add', component: GoCampaign_OfficeGroupForm, exact: true },
    { path: '/gocampaign-office-group/:id', name: 'Office Group Edit', component: GoCampaign_OfficeGroupForm },

    { path: '/gocampaign-precinct-groups', name: 'Precinct Group List', component: GoCampaign_PrecinctGroupList },
    { path: '/gocampaign-precinct-group', name: 'Precinct Group Add', component: GoCampaign_PrecinctGroupForm, exact: true },
    { path: '/gocampaign-precinct-group/:id', name: 'Precinct Group Edit', component: GoCampaign_PrecinctGroupForm },

    { path: '/gocampaign-precincts', name: 'GoCampaign Precinct List', component: GoCampaign_PrecinctList },
    { path: '/gocampaign-precinct', name: 'GoCampaign Precinct Add', component: GoCampaign_PrecinctForm, exact: true },
    { path: '/gocampaign-precinct/:id', name: 'GoCampaign Precinct Edit', component: GoCampaign_PrecinctForm },

    { path: '/gocampaign-counties', name: 'GoCampaign County List', component: GoCampaign_CountyList },
    { path: '/gocampaign-county', name: 'GoCampaign County Add', component: GoCampaign_CountyForm, exact: true },
    { path: '/gocampaign-county/:id', name: 'GoCampaign County Edit', component: GoCampaign_CountyForm },

/*  VoterDB */

    { path: '/voterdb-voters', name: 'Voter List', component: VoterDB_VotersList },
    { path: '/voterdb-voter', name: 'Voter Add', component: VoterDB_VotersForm, exact: true },
    { path: '/voterdb-voter/:id', name: 'Voter Edit', component: VoterDB_VotersForm },

    { path: '/export-types', name: 'Export Type List', component: ExportTypeList },
    { path: '/export-type', name: 'Export Type Add', component: ExportTypeForm, exact: true },
    { path: '/export-type/:id', name: 'Export Type Edit', component: ExportTypeForm },

    { path: '/export-type-filters', name: 'Export Type Filter List', component: ExportTypeFilterList },
    { path: '/export-type-filter', name: 'Export Type Filter Add', component: ExportTypeFilterForm, exact: true },
    { path: '/export-type-filter/:id', name: 'Export Type Filter Edit', component: ExportTypeFilterForm },

    { path: '/export-jobs', name: 'Export Job List', component: ExportJobList },
    { path: '/export-job', name: 'Export Job Add', component: ExportJobForm, exact: true },
    { path: '/export-job/:id', name: 'Export Job Edit', component: ExportJobForm },
];

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.js